var React = require('react');

function ExclamationMark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8","cy":"8","r":"7.5","fill":"#F5F9FF","stroke":"#30A8FF","key":0}),React.createElement("path",{"d":"M8 4.5C8.27614 4.5 8.5 4.72386 8.5 5L8.5 8.3425C8.5 8.61864 8.27614 8.8425 8 8.8425C7.72386 8.8425 7.5 8.61864 7.5 8.3425V5C7.5 4.72386 7.72386 4.5 8 4.5ZM8.5 11.5708C8.5 11.8469 8.27614 12.0708 8 12.0708C7.72386 12.0708 7.5 11.8469 7.5 11.5708C7.5 11.2947 7.72386 11.0708 8 11.0708C8.27614 11.0708 8.5 11.2947 8.5 11.5708Z","fill":"#F5F9FF","stroke":"#30A8FF","key":1})]);
}

ExclamationMark.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ExclamationMark;

ExclamationMark.default = ExclamationMark;
